import { assertBadHttpStatus } from './assert';
import { fetchGetNewbuildingLayoutsDesktop } from '../../shared/repositories/newbuilding-card/v1/get-newbuilding-layouts-desktop';
export async function fetchOffers(_ref) {
  let {
    params,
    httpApi,
    logger
  } = _ref;
  try {
    const response = await fetchGetNewbuildingLayoutsDesktop({
      httpApi,
      parameters: params,
      config: {
        requestConfig: {
          headers: [['Content-Type', 'application/json']]
        }
      }
    });
    assertBadHttpStatus(response);
    return response.response.layout || null;
  } catch (error) {
    logger.error(error, {
      domain: 'src/services/fetchOffers'
    });
    return null;
  }
}